
































import {Component, Mixins} from 'vue-property-decorator'
import {$, PageCollection} from 'simpli-web-sdk'
import {MixinFilter} from '@/components/mixins/MixinFilter'
import {AppConfig} from '@/config/app.config'
import {snakeCase} from 'lodash'
import * as Helper from '@/helpers'
import FilterToggle from '@/components/FilterToggle.vue'
import FilterDeliveryAlertHistory from '@/components/filters/FilterDeliveryAlertHistory.vue'
import DeliveryAlertHistoryRequest from '@/model/request/DeliveryAlertHistoryRequest'
import DeliveryAlertHistoryResponse from '@/model/response/DeliveryAlertHistoryResponse'

const metaInfo = () => ({
title: $.t('view.reports.deliveryAlertHistory.title'),
})

@Component({
  metaInfo,
  components: {FilterDeliveryAlertHistory, FilterToggle},
})
export default class ReportsDeliveryAlertHistoryView extends Mixins(MixinFilter) {
    filter = new DeliveryAlertHistoryRequest()
    collection = new PageCollection(DeliveryAlertHistoryResponse, this.filter, 10)

    AppConfig = AppConfig

  async downloadData(xlsx: boolean) {
    if (!xlsx) {
        const csv = new PageCollection(DeliveryAlertHistoryResponse, this.filter, null, null)

        const fetch = async () => await csv.search()
        await $.await.run(fetch, 'download')
        csv.downloadCsv(snakeCase($.t('view.reports.deliveryAlertHistory.title')))
    } else {
        await $.await.run(() => Helper.downloadXlsx(
          $.t('view.reports.deliveryAlertHistory.title'),
          new DeliveryAlertHistoryResponse().$endpoint,
          this.filter,
          DeliveryAlertHistoryResponse,
          'DeliveryAlertHistoryResponse',
          ), 'download')
    }
  }

    async created() {
      this.collection.orderBy = 'nome'
      this.collection.asc = true
    }
}
